module.exports = __webpack_public_path__ + "img/icon39.b868788e.png";